const config = {
    language: "en",
    langs: ["ru", "en", "de", "fr", "it"],
    facebookAppId: "344665334326716",
    googleClientId: "986517302514-l6pk1rfj6ilopqeor2hapjv9j8jrpkpu.apps.googleusercontent.com",
    // Apple Services ID (Sign in with Apple for web) — not the app bundle id
    // AI assistants tab (API tokens + MCP). Off until the @connexxtion/mcp package is published.
    aiAssistants: process.env.REACT_APP_AI_ASSISTANTS === "1",
    appleClientId: process.env.REACT_APP_APPLE_CLIENT_ID || "ch.connexxtion.web",
};

export default config;